import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Application {
    id: number;
    [key: string]: any;
}

interface ApplicationsState {
    items: Application[];
    current: Application | null;
    loading: boolean;
    error: string | null;
}

const initialState: ApplicationsState = {
    items: [],
    current: null,
    loading: false,
    error: null,
};

const applicationsSlice = createSlice({
    name: 'applications',
    initialState,
    reducers: {
        setApplications(state, action: PayloadAction<Application[]>) {
            state.items = action.payload;
            state.loading = false;
            state.error = null;
        },
        setApplication(state, action: PayloadAction<Application | null>) {
            state.current = action.payload;
        },
        addApplication(state, action: PayloadAction<Application>) {
            state.items.push(action.payload);
        },
        updateApplication(state, action: PayloadAction<Application>) {
            const index = state.items.findIndex(item => item.id === action.payload.id);
            if (index !== -1) {
                state.items[index] = action.payload;
            }
            if (state.current?.id === action.payload.id) {
                state.current = action.payload;
            }
        },
        removeApplication(state, action: PayloadAction<number>) {
            state.items = state.items.filter(item => item.id !== action.payload);
            if (state.current?.id === action.payload) {
                state.current = null;
            }
        },
        setApplicationsLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setApplicationsError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
            state.loading = false;
        },
        clearApplications(state) {
            state.items = [];
            state.current = null;
        },
    },
});

export const {
    setApplications,
    setApplication,
    addApplication,
    updateApplication,
    removeApplication,
    setApplicationsLoading,
    setApplicationsError,
    clearApplications,
} = applicationsSlice.actions;

export default applicationsSlice.reducer;



















